import { Injectable } from '@angular/core'

import { KeySubscriber } from '@app/core/key-subscriber'

@Injectable({
  providedIn: 'root',
})
export class HeaderService extends KeySubscriber {
  readonly hideCreditsButton$ = this.provide('hideCreditsButton')
  readonly hidingCreditsButton$ = this.observeHasSubscribers('hideCreditsButton')
}
